import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import testSlice from './slice/testSlice.tsx';
import removeSlice from './slice/remove/removeSlice.tsx';
import listSlice from './slice/form/listSlice.tsx';
import viewSlice from './slice/form/viewSlice.tsx';
import settings from '../pages/settings/redux/settings.tsx';
import selectAutocompleteSlice from '../components/autocomplete/selectAutocompleteSlice.tsx';

import kategorijaReduxSlice from '../pages/sifarnici/kategorija/reduxSlice.tsx';
import marzaReduxSlice from '../pages/sifarnici/marza/reduxSlice.tsx';
import proizvodjacReduxSlice from '../pages/sifarnici/proizvodjac/reduxSlice.tsx';
import uslugaReduxSlice from '../pages/sifarnici/usluga/reduxSlice.tsx';
import robaReduxSlice from '../pages/sifarnici/roba/reduxSlice.tsx';
import radnikReduxSlice from '../pages/sifarnici/radnik/reduxSlice.tsx';
import upravnikReduxSlice from '../pages/sifarnici/upravnik/reduxSlice.tsx';
import komitentReduxSlice from '../pages/sifarnici/komitent/reduxSlice.tsx';
import liftReduxSlice from '../pages/sifarnici/lift/reduxSlice.tsx';

import zahtevZaRadniNalogReduxSlice from '../pages/radniNalog/zahtev/reduxSlice.tsx';
import radniNalogReduxSlice from '../pages/radniNalog/radniNalog/reduxSlice.tsx';
import zahtevZaPonuduReduxSlice from '../pages/ponuda/zahtev/reduxSlice.tsx';
import ponudaReduxSlice from '../pages/ponuda/ponuda/reduxSlice.tsx';
import avansnaFakturaReduxSlice from '../pages/faktura/avansnaFaktura/reduxSlice.tsx';
import zavrsnaFakturaReduxSlice from '../pages/faktura/zavrsnaFaktura/reduxSlice.tsx';

import ugovorReduxSlice from '../pages/ugovor/reduxSlice.tsx';


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const store = configureStore({
  reducer: {
    testSlice: testSlice.reducer,
    removeSlice: removeSlice.reducer,
    listSlice: listSlice.reducer,
    viewSlice: viewSlice.reducer,
    settings: settings.reducer,
    selectAutocompleteSlice: selectAutocompleteSlice.reducer,

    kategorijaReduxSlice: kategorijaReduxSlice.reducer,
    marzaReduxSlice: marzaReduxSlice.reducer,
    proizvodjacReduxSlice: proizvodjacReduxSlice.reducer,
    uslugaReduxSlice: uslugaReduxSlice.reducer,
    robaReduxSlice: robaReduxSlice.reducer,
    radnikReduxSlice: radnikReduxSlice.reducer,
    upravnikReduxSlice: upravnikReduxSlice.reducer,
    komitentReduxSlice: komitentReduxSlice.reducer,
    liftReduxSlice: liftReduxSlice.reducer,

    zahtevZaRadniNalogReduxSlice: zahtevZaRadniNalogReduxSlice.reducer,
    radniNalogReduxSlice: radniNalogReduxSlice.reducer,
    zahtevZaPonuduReduxSlice: zahtevZaPonuduReduxSlice.reducer,
    ponudaReduxSlice: ponudaReduxSlice.reducer,
    avansnaFakturaReduxSlice: avansnaFakturaReduxSlice.reducer,
    zavrsnaFakturaReduxSlice: zavrsnaFakturaReduxSlice.reducer,

    ugovorReduxSlice: ugovorReduxSlice.reducer,
  },
});

export { store };

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAppDispatch = () => useDispatch<AppDispatch>();
